<template>
  <v-container id="data-tables" tag="section">
    <base-material-card color="blue" icon="mdi-warehouse" inline class="px-5 py-3">
      <v-spacer></v-spacer>
      <template v-slot:after-heading></template>
      <!-- Texto del boton NUEVO -->
      <template v-slot:corner-button>
        <v-btn small class="ma-2" elevation="2" color="blue" @click.stop="dialog = true"
          >Nueva Entidad</v-btn
        >
      </template>

      <!-- <v-overlay :value="overlay">
        <v-progress-circular :size="50" color="green" indeterminate></v-progress-circular>
      </v-overlay> -->

      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        class="ml-auto"
        label="Búsqueda"
        hide-details
        single-line
        style="max-width: 250px"
      />
      <!-- Empieza Dialogo Cancelar -->
      <ConfirmationDialog v-model="isSure" @click="cancel" />
      <!-- Termina Dialogo Cancelar -->
      <!-- Empieza Dialogo -->
      <v-dialog v-model="dialog" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row>
                <!-- Campo TIPO -->
                <v-col cols="6">
                  <v-select
                    v-model="$v.editedItem.id_tipo.$model"
                    :items="tipos"
                    :menu-props="{ top: true, offsetY: true }"
                    label="Tipo*"
                    item-text="tipo_nombre"
                    item-value="id_tipo"
                    persistent-hint
                    dense
                    hint="Seleciona Tipo"
                    return-object
                    :error-messages="TipoErrors"
                    @input="changed = true"
                    @blur="$v.editedItem.id_tipo.$touch()"
                  >
                  </v-select>
                </v-col>
                <!-- Campo SIGLAS -->
                <v-col cols="6">
                  <v-text-field
                    v-model="$v.editedItem.ent_siglas.$model"
                    label="Siglas"
                    counter="15"
                    dense
                    required
                    :error-messages="entidad_siglasErrors"
                    @input="$v.editedItem.ent_siglas.$reset(), (changed = true)"
                    @blur="$v.editedItem.ent_siglas.$touch()"
                  ></v-text-field>
                </v-col>

                <!-- Campo NOMBRE -->
                <v-col cols="12">
                  <v-text-field
                    v-model="$v.editedItem.ent_nombre.$model"
                    label="Nombre*"
                    counter="255"
                    required
                    :error-messages="entidad_nombreErrors"
                    @input="$v.editedItem.ent_nombre.$reset(), (changed = true)"
                    @blur="$v.editedItem.ent_nombre.$touch()"
                  ></v-text-field>
                </v-col>
                <!-- Campo ACTIVO -->
                <v-col cols="12">
                  <v-checkbox
                    v-model="editedItem.ent_activo"
                    :label="`Estatus: ${
                      editedItem.ent_activo.toString() == 'true' ? 'Activo' : 'Inactivo'
                    }`"
                    @input="$v.editedItem.ent_activo.$reset(), (changed = true)"
                    @blur="$v.editedItem.ent_activo.$touch()"
                  >
                  </v-checkbox>
                </v-col>
              </v-row>
            </v-container>
            <small>*Campo Obligatorio</small>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-checkbox v-model="checkbox" label="Crear otro" :disabled="isEditing"></v-checkbox>
            <v-btn color="red darken-1" text @click="checkChanges">Cancelar</v-btn>
            <v-btn color="blue darken-1" text @click="save" :disabled="$v.$invalid">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Termina Dialogo -->
      <!-- Aqui va progress linear -->
      <v-divider class="mt-3" />
      <v-data-table
        :headers="headers"
        :items="entidades"
        dense
        :search.sync="search"
        :loading="isLoading"
        loading-text="Cargando... Espere por favor"
      >
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
          <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
        </template>

        <!-- Creo el boton de Activo-->
        <template v-slot:item.ent_activo="{ item }">
          <Status :activostr="item.ent_activo" tipo="String" />
        </template>

        <template v-slot:no-data>
          <!-- <v-btn color="primary">Reset</v-btn> -->
          ¡No hay datos para mostrar!
        </template>
      </v-data-table>
      <!-- Termina Tabla de Entidades -->
      <!-- Empieza DataExporter -->
      <DataExporter :dataArray="entidades" :dataFields="fields" fileName="Entidades" />
      <!-- Termina DataExporter -->
    </base-material-card>
  </v-container>
</template>

<script>
import ConfirmationDialog from '@/components/general/ConfirmationDialog.vue'
import Status from '@/components/general/StatusInfo.vue'
import { getValidToken } from '@/store/helpers.js'
import { validationMixin } from 'vuelidate'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import DataExporter from '@/components/general/DataExporter.vue'
export default {
  components: {
    ConfirmationDialog,
    Status,
    DataExporter,
  },

  data: () => ({
    search: undefined,
    isLoading: false,
    checkbox: false,
    isEditing: false,
    dialog: false,
    isSure: false,
    overlay: false,
    changed: false,
    headers: [
      { text: 'Entidad', align: 'start', sortable: false, value: 'id_entidad' },
      { text: 'Tipo', value: 'tipo_nombre' },
      //{ text: 'Tipo', value: 'tipo.tipo_nombre' },
      { text: 'Nombre', value: 'ent_nombre' },
      { text: 'Siglas', value: 'ent_siglas' },
      { text: 'Activo', value: 'ent_activo' },
      { text: 'Acciones', value: 'actions', sortable: false },
    ],
    //
    value: [],
    entidades: [],
    tipos: [],
    editedIndex: -1,
    editedItem: {
      id_entidad: 0,
      id_tipo: 0,
      tipo_nombre: '',
      //tipo: { id_tipo: 0, tipo_nombre: '' },
      ent_nombre: '',
      ent_siglas: '',
      ent_activo: true,
    },
    defaultItem: {
      id_entidad: 0,
      id_tipo: 0,
      tipo_nombre: '',
      //tipo: { id_tipo: 0, tipo_nombre: '' },
      ent_nombre: '',
      ent_siglas: '',
      ent_activo: true,
    },
    //Para Exportar
    fields: {
      Entidad: 'id_entidad',
      Tipo: 'tipo_nombre',
      Nombre: 'ent_nombre',
      Activo: 'ent_activo',
    },
  }),

  mixins: [validationMixin],
  //Validaciones para los campos del formulario
  validations: {
    editedItem: {
      ent_nombre: { required, minLength: minLength(3), maxLength: maxLength(255) },
      //id_tipo: { required, minLength: minLength(3), maxLength: maxLength(255) },
      ent_siglas: { required, minLength: minLength(3), maxLength: maxLength(100) },
      id_tipo: { required },
    },
  },

  computed: {
    //Titulo de los formularios
    formTitle() {
      return this.editedIndex === -1 ? 'Nueva Entidad' : 'Editar Entidad'
    },
    entidad_siglasErrors() {
      const errors = []
      if (!this.$v.editedItem.ent_siglas.$dirty) return errors
      !this.$v.editedItem.ent_siglas.required && errors.push('Este campo es requerido')
      !this.$v.editedItem.ent_siglas.minLength &&
        errors.push('Este campo debe de tener un mínimo de 3 caracteres.')
      !this.$v.editedItem.ent_siglas.maxLength &&
        errors.push('Este campo debe de tener un máximo de 20 caracteres.')
      return errors
    },
    entidad_nombreErrors() {
      const errors = []
      if (!this.$v.editedItem.ent_nombre.$dirty) return errors
      !this.$v.editedItem.ent_nombre.required && errors.push('Este campo es requerido')
      !this.$v.editedItem.ent_nombre.minLength &&
        errors.push('Este campo debe de tener un mínimo de 3 caracteres.')
      !this.$v.editedItem.ent_nombre.maxLength &&
        errors.push('Este campo debe de tener un máximo de 20 caracteres.')
      return errors
    },
    TipoErrors() {
      const errors = []
      if (!this.$v.editedItem.id_tipo.$dirty) return errors
      !this.$v.editedItem.id_tipo.required && errors.push('Este campo es requerido')
      return errors
    },
    /* TiposErrors() {
      const errors = []
      if (!this.$v.editedItem.id_tipo.$dirty) return errors
      !this.$v.editedItem.id_tipo.required && errors.push('Este campo es requerido')
      return errors
    }, */
  },

  watch: {
    dialog(val) {
      val || this.close()
    },
  },
  //1ero
  created() {
    this.iniciando()
  },

  methods: {
    //Refresca Datos para la tabla
    async iniciando() {
      let jwt = await getValidToken(this)
      this.obtenerTipos(jwt)
      this.obtenerEntidades(jwt)
    },
    //Obtiene todos los tipos para el select
    async obtenerTipos(jwt) {
      this.isLoading = true
      //let jwt = await getValidToken(this)
      if (jwt != null) {
        let payload = { jwt: jwt }
        this.$store
          .dispatch('tipo/fetchTipo', payload)
          .then((response) => {
            this.tipos = response.data
            this.isLoading = false
          })
          .catch((err) => {
            this.isLoading = false
            this.$store.commit('ALERT', {
              color: 'error',
              text: err.response.data.error,
              // Enviar a inicio de sesión
            })
          })
      }
    },
    //Obtiene Todos las Entidades para la tabla
    async obtenerEntidades(jwt) {
      this.isLoading = true
      //let jwt = await getValidToken(this)
      if (jwt != null) {
        let payload = { jwt: jwt }
        this.$store
          .dispatch('entidad/fetchEntidad', payload)
          .then((response) => {
            this.entidades = response.data
            this.isLoading = false
          })
          .catch((err) => {
            this.isLoading = false
            this.$store.commit('ALERT', {
              color: 'error',
              text: err.response.data.error,
              // Enviar a inicio de sesión
            })
          })
      }
    },
    // Editar Tipo
    editItem(item) {
      this.isEditing = true
      this.editedIndex = this.entidades.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.editedItem.ent_activo = this.editedItem.ent_activo == 1 ? true : false
      this.dialog = true
    },
    // Eliminar Tipo
    deleteItem(item) {
      const index = this.entidades.indexOf(item)
      //Confirma cerrar formulario
      confirm('Esta seguro que desea eliminar este registro?') && this.entidades.splice(index, 1)
      this.Borrar(item.id_entidad)
    },
    //Borrar en BD es desActivar
    async Borrar(index) {
      this.overlay = true
      this.$v.$touch()

      let body = {
        //_id: this.editedItem.id_tipo,
        id_entidad: index,
        //tipo_nombre: this.editedItem.tipo_nombre,
        ent_activo: 0,
      }
      let jwt = await getValidToken(this)
      let payload = { jwt: jwt, body: body }
      payload.id = index
      this.$store
        .dispatch('entidad/deleteEntidad', payload)
        .then(() => {
          this.$store.commit('ALERT', {
            color: 'success',
            text: 'El registro se eliminó con éxito',
          })
          this.overlay = false
        })
        .catch((err) => {
          this.$store.commit('ALERT', {
            color: 'error',
            text: err.response.data.msg,
            // Enviar a inicio de sesión
          })
          this.overlay = false
        })
      Object.assign(this.entidades[this.editedIndex], this.editedItem)
    },
    // Revisar los cambios en el formulario
    checkChanges() {
      if (this.changed) {
        this.isSure = true
      } else {
        this.close(false)
        this.changed = false
      }
    },

    cancel(isSure) {
      this.isSure = isSure
      if (this.isSure) {
        this.close(false)
        this.changed = false
      }
    },

    // Cerrar el formulario
    close(checkbox) {
      this.isSure = false
      this.checkbox = checkbox
      if (!this.checkbox) {
        this.dialog = false
        this.isEditing = false
      }
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
      this.$v.$reset()
    },

    // Guardar el formulario
    async save() {
      this.overlay = true
      this.$v.$touch()
      if (!this.$v.$invalid) {
        let tipo = 0
        if (this.editedItem.id_tipo.id_tipo == null) {
          tipo = this.editedItem.id_tipo
        } else {
          tipo = this.editedItem.id_tipo.id_tipo
        }
        let body = {
          //id_tipo: this.editedItem.id_tipo,
          //id_tipo: this.editedItem.id_tipo.id_tipo,
          id_tipo: tipo,
          ent_nombre: this.editedItem.ent_nombre,
          ent_siglas: this.editedItem.ent_siglas,
          ent_activo: this.editedItem.ent_activo == true ? 1 : 0,
        }
        console.log(tipo)
        //console.log(body)

        let jwt = await getValidToken(this)
        let payload = { jwt: jwt, body: body }
        if (this.editedIndex > -1) {
          payload.id = this.editedItem.id_entidad
          this.$store
            .dispatch('entidad/editEntidad', payload)
            .then(() => {
              this.$store.commit('ALERT', {
                color: 'success',
                text: 'El registro se actualizo con éxito',
              })
              this.overlay = false
            })
            .catch((err) => {
              this.$store.commit('ALERT', {
                color: 'error',
                text: err.response.data.msg,
                // Enviar a inicio de sesión
              })
              this.overlay = false
            })
          Object.assign(this.entidades[this.editedIndex], this.editedItem)
        } else {
          this.$store
            .dispatch('entidad/addEntidad', payload)
            .then((response) => {
              this.$store.commit('ALERT', {
                color: 'success',
                text: 'El registro se creó con éxito',
              })
              this.entidades.push(response.data)
              this.overlay = false
            })
            .catch((err) => {
              this.$store.commit('ALERT', {
                color: 'error',
                text: err.response.data.msg,
                // Enviar a inicio de sesión
              })
              this.overlay = false
            })
        }
        this.close(this.checkbox)
        this.changed = false
        jwt = await getValidToken(this)
        this.obtenerEntidades(jwt)
      }
    },
  },
}
</script>
